import { CropDialogMenu as e } from "./Menu.es.js";
import { Softcrop as t } from "./Softcrop.es.js";
import { Grid as n } from "./Grid.es.js";
import { useRef as r, useState as i } from "react";
import { Fragment as a, jsx as o, jsxs as s } from "react/jsx-runtime";
//#region lib/components/CropDialog/CropDialog.tsx
var c = ({ src: c, area: l, point: u, onChange: d, enableFocusPoint: f = !0, enableDragHandles: p = !0, enablePanAndZoom: m = !0 }) => {
	let [h, g] = i(!1), _ = r(null);
	return /* @__PURE__ */ s(a, { children: [h && /* @__PURE__ */ o(t, {
		ref: _,
		src: c,
		enableDragHandles: p,
		enableFocusPoint: f,
		enablePanAndZoom: m,
		onReady: () => {
			if (_.current) {
				if (l) {
					let { x: e, y: t, w: n, h: r } = l;
					_.current.setCropArea(e, t, n, r);
				}
				if (u) {
					let { x: e, y: t } = u;
					_.current.setFocusPoint(e, t);
				}
			}
		},
		children: /* @__PURE__ */ o(n, {})
	}), /* @__PURE__ */ o(e, {
		active: h,
		onToggle: (e) => {
			!e && _.current && d({
				crop: _.current.getCropArea(),
				focus: _.current.getFocusPoint()
			}), g(e);
		},
		onZoom: (e) => {
			_.current && (e === "in" ? _.current.zoomIn() : _.current.zoomOut());
		},
		onReset: () => {
			_.current?.reset();
		}
	})] });
};
//#endregion
export { c as CropDialog };
